import { render, staticRenderFns } from "./MiniUserRoute.vue?vue&type=template&id=76e75072&"
import script from "./MiniUserRoute.vue?vue&type=script&lang=js&"
export * from "./MiniUserRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports